import React from 'react';

import Group from '@lightspeed/cirrus-group';
import { ModalFooter } from '@lightspeed/cirrus-modal';
import { Button } from '@lightspeed/flame/Button';
import PropTypes from 'prop-types';

import { PaymentMethod, TransactionState } from './ManualPaymentTypes';

const ManualPaymentFooter = ({
  selectedTerminal,
  areFieldsValid,
  isManualAuthorized,
  selectedManualMethod,
  transactionState,
  onCancel,
  onOk,
  onStartPayment,
  onRetryPayment,
  onEnterDetails,
  onDone,
}) => {
  let footer = null;

  switch (transactionState) {
    case TransactionState.IN_PROGRESS:
      footer = (
        <div className="quick-pay-modal__footer quick-pay-modal__footer--centered cirrus">
          <Group>
            <Button onClick={onCancel} disabled={selectedManualMethod === PaymentMethod.MANUAL_POS}>
              Cancel
            </Button>
          </Group>
        </div>
      );
      break;

    case TransactionState.COMPLETE:
      footer = (
        <div className="quick-pay-modal__footer quick-pay-modal__footer--centered cirrus">
          <Group>
            <Button variant="primary" fill onClick={onDone}>
              Back to Sale
            </Button>
          </Group>
        </div>
      );
      break;

    case TransactionState.CANCELED:
    case TransactionState.DECLINED:
    case TransactionState.FAILED:
    case TransactionState.ERROR:
      footer = (
        <div className="quick-pay-modal__footer cirrus">
          <Group>
            <Button onClick={onCancel}>Close</Button>
            <Button variant="primary" fill onClick={onRetryPayment}>
              Retry
            </Button>
          </Group>
        </div>
      );
      break;

    case TransactionState.CANCEL_FROM_TERMINAL:
      footer = (
        <div className="quick-pay-modal__footer quick-pay-modal__footer--centered cirrus">
          <Group>
            <Button onClick={onOk}>OK</Button>
          </Group>
        </div>
      );
      break;

    case TransactionState.WAITING_TO_START:
      const disableStartTransaction = !selectedTerminal;
      const actionButton =
        selectedManualMethod === PaymentMethod.MANUAL_TERMINAL ? (
          <Button
            variant="primary"
            fill
            onClick={onStartPayment}
            disabled={disableStartTransaction}
          >
            Start Payment
          </Button>
        ) : (
          <Button variant="primary" fill onClick={onEnterDetails} disabled={!areFieldsValid}>
            Enter Card Details
          </Button>
        );
      footer = (
        <div className="cirrus cr-flex cr-justify-end">
          <Group>
            <Button onClick={onCancel}>Cancel</Button>
            {actionButton}
          </Group>
        </div>
      );
      break;

    case TransactionState.ENTER_CARD_DETAILS:
      footer = (
        <div className="cirrus cr-flex cr-justify-end">
          <Group>
            <Button onClick={onCancel} disabled={!isManualAuthorized}>
              Cancel
            </Button>
            <Button variant="primary" fill onClick={onStartPayment} disabled={!isManualAuthorized}>
              Start Payment
            </Button>
          </Group>
        </div>
      );
      break;

    default:
      break;
  }

  return <ModalFooter>{footer}</ModalFooter>;
};

ManualPaymentFooter.propTypes = {
  selectedTerminal: PropTypes.shape(PropTypes.any.object),
  areFieldsValid: PropTypes.bool,
  isManualAuthorized: PropTypes.bool,
  selectedManualMethod: PropTypes.string,
  transactionState: PropTypes.string,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  onStartPayment: PropTypes.func,
  onRetryPayment: PropTypes.func,
  onEnterDetails: PropTypes.func,
};

ManualPaymentFooter.defaultProps = {
  selectedTerminal: null,
  areFieldsValid: true,
  isManualAuthorized: false,
  selectedManualMethod: PaymentMethod.MANUAL_TERMINAL,
  transactionState: TransactionState.WAITING_TO_START,
  onCancel: () => {},
  onOk: () => {},
  onStartPayment: () => {},
  onRetryPayment: () => {},
  onEnterDetails: () => {},
  // eslint-disable-next-line react/default-props-match-prop-types
  onDone: () => {},
};

export default ManualPaymentFooter;
